<style lang="scss" scoped>
.slide-13 {
  background-image: url(../../../assets/module2/slide13/background-01.jpg);
  background-position: center;
  background-size: cover;
  padding-top: 80px;

  .pages {
    padding: 0 4%;
  }

  .page-left {
    padding-right: 0;
  }

  .page-right {
    padding-left: 30px;
    padding-right: 50px;
  }

  .heading1 {
    transform: rotate(-10deg);
    transform-origin: 30% 0;
    font-size: 80px;
  }
  .heading2 {
    color: #f9e17e;
    margin-left: 170px;
  }
  .heading3 {
    color: #f9e17e;
    margin-left: 20px;
  }
  .heading4 {
    color: #f9e17e;
    margin-left: 40px;
  }
  .heading5 {
  }
  .copy1 {
    width: 70%;
    margin: 30px auto;
  }

  .heading6 {
    color: #09509c;
    width: 70%;
    margin: auto;
  }
  .heading7 {
    width: 100%;
    text-align: center;
    font-size: 90px;
    transform: rotate(-5deg);
    margin: 20px 0;
  }
  .heading8 {
    width: 100%;
    text-align: center;
    font-size: 190px;
  }
  .heading9 {
    color: #09509c;
    margin-top: 230px;
    font-family: "Kookycat-FASTcaps";
    font-weight: 100;
    font-size: 40px;
  }
  .copy2 {
    color: #fff;
    font-family: "Comfortaa-FAST";
    display: inline;
    font-size: 34px;
  }
  .copy3 {
    margin-top: 320px;
  }

  .white {
    color: #fff;
  }

  .red {
    color: #c90c0f;
  }

  .download {
    transition: all 0.2s ease-out;
    position: absolute;
    top: 48%;
    right: 80px;
    transform: scale(1);
    &:hover {
      transform: scale(1.1);
    }
  }

  @media screen and (min-width: 0\0) {
    .heading2,
    .heading3,
    .heading4,
    .heading5,
    .heading6 {
      font-size: 50px;
    }
    .heading7 {
      font-size: 70px;
    }
    .heading8 {
      font-size: 150px;
    }
  }
}
#pdfDocument {
  cursor: pointer;
}
</style>

<template>
  <div class="slide-13">
    <transition name="fadeRight" appear>
      <img
        v-show="slideIndex == 12"
        src="@/assets/module2/slide13/images-01.png"
        class="chars delay-2"
      />
    </transition>
    <transition name="fadeRight" appear>
      <img
        v-show="slideIndex == 12"
        src="@/assets/module2/slide13/photo-01.png"
        class="chars delay-5"
      />
    </transition>

    <div class="pages">
      <div class="page page-left">
        <transition name="fadeDown" appear>
          <div class="delay-1" v-show="slideIndex == 12">
            <h1 class="heading1" v-html="$t('module2.slide13.heading1')"></h1>
          </div>
        </transition>

        <transition name="fadeLeft" appear>
          <h1
            v-show="slideIndex == 12"
            class="heading2 delay-2"
            v-html="$t('module2.slide13.heading2')"
          ></h1>
        </transition>
        <transition name="fadeLeft" appear>
          <h1 v-show="slideIndex == 12" class="heading3 delay-3">
            {{ $t("module2.slide13.heading3") }}
          </h1>
        </transition>
        <transition name="fadeLeft" appear>
          <h1 v-show="slideIndex == 12" class="heading4 delay-4">
            {{ $t("module2.slide13.heading4") }}
          </h1>
        </transition>
        <transition name="fadeLeft" appear>
          <h1 v-show="slideIndex == 12" class="heading5 delay-5">
            {{ $t("module2.slide13.heading5") }}
          </h1>
        </transition>

        <transition name="fadeUp" appear>
          <div v-show="slideIndex == 12" class="delay-2">
            <p class="copy1">{{ $t("module2.slide13.copy1") }}</p>
          </div>
        </transition>

        <transition name="fadeUp" appear>
          <div v-show="slideIndex == 12" class="number-wrapper delay-3">
            <h1 class="heading6">{{ $t("module2.slide13.heading6") }}</h1>
            <h1 class="heading7">{{ $t("module2.slide13.heading7") }}</h1>
            <h1 class="heading8">
              <span class="red">{{ $t("module2.slide13.heading8") }}</span>
            </h1>
          </div>
        </transition>
      </div>

      <div class="page page-right">
        <transition name="fadeRight" appear>
          <div class="delay-3" v-show="slideIndex == 12">
            <p class="heading9">
              {{ $t("module2.slide13.heading9") }}
              <span class="copy2">{{ $t("module2.slide13.copy2") }}</span>
            </p>
          </div>
        </transition>

        <transition name="scale" appear>
          <a
            class="download delay-7"
            :href="pdfLink"
            v-show="slideIndex == 12"
            target="_blank"
          >
            <img src="@/assets/module2/slide13/1x/dowload_print.png" />
          </a>
        </transition>

        <transition name="fadeRight" appear>
          <div class="delay-4" v-show="slideIndex == 12">
            <p class="copy3">{{ $t("module2.slide13.copy3") }}</p>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    slideIndex: { type: Number },
    imageId: { type: String, default: "0" }
  },
  data() {
    return {
      pdfLink:
        window?.CF_EBOOK_VARS?.documents?.book_2_document_2.url ||
        "../phone_sticker.pdf"
    };
  },
  methods: {
    downloadLegacy() {
      let doc = this.$el.querySelector("#pdfDocument");
      doc.focus();
      doc.contentWindow.print();
    }
  }
};
</script>
